import { render, staticRenderFns } from "./CriteriaAddLocalisedOrValues.vue?vue&type=template&id=44018588"
import script from "./CriteriaAddLocalisedOrValues.vue?vue&type=script&lang=js"
export * from "./CriteriaAddLocalisedOrValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports